import React from 'react';
import { MotionConfig } from 'motion/react';
import { EASE_OUT, DURATION } from './tokens';

export default function MotionProvider({ children }) {
  return (
    <MotionConfig
      reducedMotion="user"
      transition={{ duration: DURATION.normal, ease: EASE_OUT }}
    >
      {children}
    </MotionConfig>
  );
}
